/**
 * App — root layout. Header / main (SwapCard) / Footer.
 */

import { Header } from "./components/Header";
import { SwapCard } from "./components/SwapCard";
import { Footer } from "./components/Footer";

export function App() {
  return (
    <div className="flex min-h-full flex-col">
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} className="flex-1 px-4 py-8 sm:px-6 sm:py-14">
        <div className="mx-auto max-w-5xl">
          <div className="mb-8 text-center">
            <h1 className="text-[clamp(26px,4vw,36px)] font-semibold tracking-tight text-[--text]">
              Every ASIC pool. One trade.
            </h1>
            <p className="mx-auto mt-2 max-w-xl text-[13px] text-[--text-muted]">
              A specialized aggregator that splits USDC ↔ ASIC across every
              Uniswap V2 / V3 / V4 venue on Ethereum, leaving nothing for MEV
              bots to arb.
            </p>
          </div>
          <SwapCard />
        </div>
      </main>
      <Footer />
    </div>
  );
}
